import moment from 'moment-timezone';


export const convertDateToUTC = (dateObj) => {
  const date = dateObj.Date;
  const time = dateObj.Time;
  const utcOffset = dateObj.UTCOffset;

  const momentString = [date, time].join(' ');

  const convertedDate = moment(momentString, 'YYYY-MM-DD HH:mm:ss');
  convertedDate.utcOffset(utcOffset, true);

  return convertedDate.format();
};

export const getDefaultTimezone = () => {
  const tzName = moment.tz.guess();
  if (tzName) {
    return tzName;
  }
  return 'UTC';
};



// WEBPACK FOOTER //
// ./src/utility/date.js